import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';
import { formatPrice } from '../../../quotes/priceFormatter';

const CustomLineItem = ({ item, isoCurrencySymbol }) => {
  return (
    <tr>
      <td className="text-start product-details">
        <div className="group-name">{item.name}</div>
        <div>{item.partNumber}</div>
        <div className="text-break-line">{item.description}</div>
      </td>
      <td className="price-breakdown">
        <div className="row price-heading-mobile">
          <div className="col-6"></div>
          <div className="col-6 price-heading">D. NET</div>
        </div>
        {item.subLineItems.length > 0 && (
          <div className="row">
            <div className="col-6">Base price</div>
            <div className="col-6">{formatPrice(item.price)}</div>
          </div>
        )}
        {item.subLineItems.map((subLineItem, idx) => (
          <div className="row" key={idx}>
            <div className="col-6">{subLineItem.description}</div>
            <div className="col-6">{formatPrice(subLineItem.price)}</div>
          </div>
        ))}
        <div className="row unit-price">
          <div className="col-6">Unit Price</div>
          <div className="col-6">{formatPrice(item.unitPrice)}</div>
        </div>
        <div className="row">
          <div className="col-3">Quantity</div>
          <div className="col-3 text-center">{item.quantity}</div>
        </div>
        <div className="row total-price">
          <div className="col-6">Total ({isoCurrencySymbol})</div>
          <div className="col-6">{formatPrice(item.totalPrice)}</div>
        </div>
      </td>
    </tr>
  );
};

export default class OrderCustomLineItemsComponent extends React.PureComponent {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
  };

  render() {
    const { order } = this.props;

    if (order.customLineItems.length === 0) return null;
    return (
      <div className="col">
        <div className="card mb-4 box-shadow h-100">
          <div className="card-body">
            <h6 className="card-title text-center">Custom Line Items</h6>
            <table className="table order-view-table order-view-products-table table-mobile">
              <thead>
                <tr>
                  <th width="55%" className="text-start">
                    Details
                  </th>
                  <th width="45%">
                    <div className="row">
                      <div className="col-6"></div>
                      <div className="col-6 text-end">D. NET</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {order.customLineItems.map((item) => (
                  <CustomLineItem
                    key={item.id}
                    item={item}
                    isoCurrencySymbol={order.isoCurrencySymbol}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
